export default "__VITE_ASSET__DRlnMprA__"